import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { printOrderSummaryFromShipmentsGrid } from '../../../../store/printing/print.actions';
import { useGetPrintSettingsForDocumentType } from '../../../../hooks/use-get-print-settings-for-document-type';
import { DocumentType } from '../../../../enums/document-type';

export const useOrderSummary = ({ fulfillments }) => {
  const dispatch = useDispatch();
  const isDisabled = fulfillments.length === 0;
  const fulfillmentPlanIds = useMemo(() => fulfillments.map((f) => f.fulfillmentPlanId), [fulfillments]);
  const doesPrintSettingExist = !!useGetPrintSettingsForDocumentType(DocumentType.OrderSummary.printSettingKey);

  const onPrint = useCallback(() => {
    dispatch(printOrderSummaryFromShipmentsGrid(fulfillmentPlanIds, !doesPrintSettingExist));
  }, [dispatch, fulfillmentPlanIds, doesPrintSettingExist]);

  return useMemo(
    () => ({
      isDisabled,
      onClick: onPrint,
      onPrint,
    }),
    [isDisabled, onPrint],
  );
};
